import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const DeleteOrgUnitAthleteEntryOrgUnitNonAthleteEntryData = (orgUnitAthleteEntryOrgUnitNonAthleteEntryId, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Deleting...'
    };
    setState(newState);

    const orgUnitAthleteEntryOrgUnitNonAthleteEntryIdForUrl = orgUnitAthleteEntryOrgUnitNonAthleteEntryId ? encodeURIComponent(orgUnitAthleteEntryOrgUnitNonAthleteEntryId) : 'NaN';
    const url = `/OrgUnitAthleteEntryOrgUnitNonAthleteEntry/${orgUnitAthleteEntryOrgUnitNonAthleteEntryIdForUrl}`;
    MeetHttpHelper(url, 'DELETE')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          })
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeleteOrgUnitAthleteEntryOrgUnitNonAthleteEntryData;